import { render } from "./CtaButton.vue?vue&type=template&id=133bd048&scoped=true"
import script from "./CtaButton.vue?vue&type=script&lang=js"
export * from "./CtaButton.vue?vue&type=script&lang=js"

import "./CtaButton.vue?vue&type=style&index=0&id=133bd048&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133bd048"]])

export default __exports__